<ion-card *ngIf="emp">

  <ion-row *ngIf="emp.user">
    <ion-col size="4" sizeMd="5">

    </ion-col>
    <ion-col size="4" sizeMd="2" class="textCenter">
      <!-- https://firebasestorage.googleapis.com/v0/b/allyot-ea84d.appspot.com/o/vanshavali%2FprofileImg%2F1724264943117.jpg?alt=media&token=65e60561-7e7e-439d-ac37-60d15340c3ae -->
      <app-attachment-display (onUpload)="afterUpload($event)" [(attachmentUrl)]="emp.user.url" [type]="'IMAGE'"
        [path]="'vanshavali/profileImg/'" [canEdit]="true">
      </app-attachment-display>
    </ion-col>
    <ion-col size="4" sizeMd="5">
      <ion-icon color="danger" name="close" (click)="emp.user.url=null"></ion-icon>
    </ion-col>
    <!-- <ion-col size="4" sizeMd="0" *ngIf="platform.width()<platform.height()">
      <ion-button (click)="onClickContact()" size="small"
        *ngIf="emp.user.user_pd.status!='Verified' && auth.loggedInEmployee.id!=emp.id">
        <ion-icon name="call"></ion-icon>
        Contacts
      </ion-button>
      <ion-button fill="outline" color="success" size="small" *ngIf="emp.user.user_pd.status=='Verified'">
        <ion-icon name="checkmark-done"></ion-icon>
        Verified
      </ion-button>
    </ion-col> -->

    <ion-col size="6" sizeMd="6">
      <app-a-input [label]="trans.translate('Name')" [validations]="['mandatory',toastService.checkValidation]"
        [validationObject]="emp.user" [(variable)]="emp.user.name"></app-a-input>
      <!-- <app-a-input [label]="'Name'" [(variable)]="emp.user.name"></app-a-input> -->
    </ion-col>

    <ion-col size="6" sizeMd="6">
      <app-a-input [label]="trans.translate('SurName')" [(variable)]="emp.user.last_name"></app-a-input>
    </ion-col>

    <ion-col size="3" sizeMd="3" class="borderMedium" style="margin-left: 10px;">
      {{'Gender'| translate}} *
    </ion-col>
    <ion-col size="4.3" sizeMd="4.3" (click)="emp.user.gender='MALE'" class="borderMedium">{{'Male' |translate}}

      <ion-icon name="man" class="font2" color="tertiary" *ngIf="emp.user.gender=='MALE'"></ion-icon>
      <ion-icon name="man-outline" class="font2" color="medium" *ngIf="emp.user.gender=='FEMALE'"></ion-icon>

    </ion-col>
    <ion-col size="4.3" sizeMd="4.3" (click)="emp.user.gender='FEMALE'" class="borderMedium">{{'Female' |translate}}
      <ion-icon name="woman" class="font2" color="danger" *ngIf="emp.user.gender=='FEMALE'"></ion-icon>
      <ion-icon name="woman-outline" class="font2" color="medium" *ngIf="emp.user.gender=='MALE'"></ion-icon>
    </ion-col>
    <ion-col size="12" class="padding5"> </ion-col>
    <ion-col size="3" sizeMd="3" class="borderMedium" style="margin-left: 10px;">
      {{'Marital Status' | translate}} *
    </ion-col>
    <ion-col size="4.3" sizeMd="4.3" (click)="emp.user.user_pd.marital='Married'" class="borderMedium">{{'Married' |
      translate}}

      <ion-badge class="font0_8" color="tertiary" *ngIf="emp.user.user_pd.marital=='Married'">M</ion-badge>
      <ion-badge class="font0_8" color="medium" *ngIf="emp.user.user_pd.marital!='Married'">M</ion-badge>

    </ion-col>
    <ion-col size="4.3" sizeMd="4.3" (click)="emp.user.user_pd.marital='UnMarried'" class="borderMedium">{{'UnMarried'
      |translate}}
      <ion-badge class="font0_8" color="medium" *ngIf="emp.user.user_pd.marital!='UnMarried'">S</ion-badge>
      <ion-badge class="font0_8" color="danger" *ngIf="emp.user.user_pd.marital=='UnMarried'">S</ion-badge>
    </ion-col>
    <ion-col size="12" class="padding5">
      <ion-row>
        <ion-col size="5">
          <app-a-select [label]="'Code'" [(variable)]="emp.user.user_pd.country_code"
            [objectList]="countryService.countries" [type]="'Object'" [value]="'code'"
            [display]="'displayLabel'"></app-a-select>
        </ion-col>
        <ion-col size="7">
          <app-a-input [label]="trans.translate('Mobile')" [(variable)]="emp.user.user_pd.mobile"
            (onBlur)="onBlurMobile()"></app-a-input>
        </ion-col>
      </ion-row>
    </ion-col>

    <ion-col size="12" sizeMd="4" class="padding5">
      <app-pincode [(variable)]="emp.user.user_pd"></app-pincode>
    </ion-col>

    <ion-col size="12" sizeMd="4" class="padding5">
      <app-a-input [label]="trans.translate('Address')" [(variable)]="emp.user.user_pd.permanent_address"></app-a-input>
    </ion-col>



    <ion-col size="12" sizeMd="4" class="padding5">
      <app-a-input [label]="trans.translate('Place of Origin')+ ' *'"
        [(variable)]="emp.user.user_pd.origin_city"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding5">
      <app-date [label]="trans.translate('Birth Date')+ ' *'" [(model)]="emp.user.dob" [minDate]="'1800-01-01'"
        [maxDate]="maxDate"></app-date>
    </ion-col>

    <ion-col size="12" sizeMd="4" class="padding5" *ngIf="auth.business.category">
      <app-a-select [label]="trans.translate('Sub Community')" [(variable)]="emp.user.user_pd.sub_community"
        [objectList]="auth.business.category"></app-a-select>
    </ion-col>

    <!-- <ion-col size="12" sizeMd="4" class="padding5" *ngIf="auth.business.tag">
      <app-a-select [label]="trans.translate('Tags')" [multiple]="true" [(variable)]="emp.user.user_pd.tag"
        [objectList]="auth.business.tag"></app-a-select>
    </ion-col> -->


    <ion-col size="12" sizeMd="4" class="padding5">
      <app-a-select [label]="trans.translate('Education')" [type]="'Object'" [value]="'value'"
        [(variable)]="emp.user.user_pd.education" [objectList]="utilityService.educationObjectList"></app-a-select>
      <app-a-input *ngIf="emp.user.user_pd.education=='Other'" [label]="'Other Education'"
        [(variable)]="emp.user.user_pd.other_education"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding5">
      <app-a-select [label]="trans.translate('Occupation')" [(variable)]="emp.user.user_pd.occupation"
        [objectList]="utilityService.occupationList"></app-a-select>
      <app-a-input *ngIf="emp.user.user_pd.occupation=='Other'" [label]="'Other Occupation'"
        [(variable)]="emp.user.user_pd.other_occupation"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding5">
      <app-a-select [label]="trans.translate('Profession')" [(variable)]="emp.user.user_pd.profession"
        [objectList]="utilityService.professionList"></app-a-select>
      <app-a-input *ngIf="emp.user.user_pd.profession=='Other'" [label]="'Other Profession'"
        [(variable)]="emp.user.user_pd.other_profession"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="4" class="padding5">
      <app-a-input [label]="trans.translate('Department')" [(variable)]="emp.user.user_pd.department"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="12" class="padding5">
      <ion-card class="padding5">
        <ion-row>
          <ion-col size="9" class="font1_5 bold">{{'Achievements / Posts' | translate}}</ion-col>
          <ion-col size="3">
            <ion-button (click)="clickAddAchievements(null)" size="small" color="success" fill="outline">
              Add New
            </ion-button>
          </ion-col>

        </ion-row>
        <div *ngIf="emp.user.user_pd.achievement && emp.user.user_pd.achievement.length>0">
          <div *ngFor="let item of emp.user.user_pd.achievement">
            <ion-row *ngFor="let key of objectKeys(item)">
              <ion-col size="1" class="bold borderMedium" (click)="deleteAchievement(item)">
                <ion-icon name="close-circle" color="danger"></ion-icon>
              </ion-col>
              <ion-col size="4" class="bold borderMedium">{{key}}</ion-col>
              <ion-col size="7" class="borderMedium" (click)="clickAddAchievements(item)">
                {{ item[key]}}
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-card>
    </ion-col>


    <ion-col size="12" sizeMd="6" class="padding5">
      <app-a-select [label]="trans.translate('Blood Group')" [(variable)]="emp.user.user_pd.blood"
        [objectList]="utilityService.bloodGroupList"></app-a-select>
    </ion-col>
    <ion-col size="12" sizeMd="6">
      <ion-col size="5" class="padding5">
        <input class="padding5" type="checkbox" [(ngModel)]="isLive" (ngModelChange)="onIsLiveChange($event)" />
        <span class="padding5">{{'Is the person Alive?'|translate}}</span>
      </ion-col>

      <ion-col size="11" sizeMd="6" class="padding5" *ngIf="!isLive">
        <app-date [label]="trans.translate('Date of Death')+ ' *'" [(model)]="emp.user.user_pd.death_date"
          [minDate]="minDate" [maxDate]="maxDate"></app-date>
      </ion-col>
    </ion-col>
    <ion-col size="12" class="padding5">
      <app-a-input [label]="trans.translate('Expertise Offer, I Want to help')"
        [(variable)]="emp.user.user_pd.expertise_offer"></app-a-input>
    </ion-col>

    <ion-col size="12" class="padding5">
      <app-a-input [label]="trans.translate('I need help in')"
        [(variable)]="emp.user.user_pd.help_required"></app-a-input>
    </ion-col>

    <ion-col size="12" class="padding5">
      <app-a-select [label]="trans.translate('Privacy')+ ' *'" [objectList]="[trans.translate('Hide Everything'),
    trans.translate('Hide Contact Info'),trans.translate('Open to connect')]"
        [(variable)]="auth.loggedInEmployee.user.user_pd.privacy"
        (variableChange)="onPrivacyChange($event)"></app-a-select>
    </ion-col>
  </ion-row>
</ion-card>